import { FunctionComponent, ReactNode, memo, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

import classNames from 'classnames';
import classes from './MyTopicsGroup.module.scss';

interface MyTopicsGroupProps {
  title: string;
  description: string;
  chips: ReactNode[];
  isLoading: boolean;
  isModal?: boolean;
}

export const MyTopicsGroup: FunctionComponent<MyTopicsGroupProps> = memo(
  ({ title, description, chips, isLoading, isModal }) => {
    const content = useMemo(() => {
      if (isLoading) {
        return (
          <Skeleton
            containerClassName={classes['my-topics-group__chips']}
            height={'2.5rem'}
            width={'6rem'}
            count={5}
            inline
          />
        );
      }

      return <div className={classes['my-topics-group__chips']}>{chips}</div>;
    }, [chips, isLoading]);

    if (!isLoading && !chips.length) {
      return null;
    }

    const TitleTag = isModal ? 'h3' : 'h2';

    return (
      <div
        className={classNames(classes['my-topics-group'], {
          [classes['my-topics-group--modal']]: isModal,
        })}
      >
        <div>
          <TitleTag className={classes['my-topics-group__title']}>{title}</TitleTag>
          <div className={classes['my-topics-group__description']}>{description}</div>
        </div>
        {content}
      </div>
    );
  }
);
